import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import Building from '@crehana/compass.icons.outline/Building';
import ColorPalette from '@crehana/compass.icons.outline/ColorPalette';
import Folder from '@crehana/compass.icons.outline/Folder';
import Megaphone from '@crehana/compass.icons.outline/Megaphone';
import Repeat from '@crehana/compass.icons.outline/Repeat';
import Shield from '@crehana/compass.icons.outline/Shield';
import { isProduction } from "../../../../constants";
import { HelperTooltip } from "../../../SidebarMenu/components";
import useAdminTranslations from "../useAdminTranslations";
import { jsx as _jsx } from "react/jsx-runtime";
export var useManageLinks = function useManageLinks(_ref) {
  var organizationSlug = _ref.organizationSlug,
    adminSubmodules = _ref.adminSubmodules,
    withAdminPanelNavigation = _ref.withAdminPanelNavigation;
  var _useAdminTranslations = useAdminTranslations(),
    t = _useAdminTranslations.t;
  var adminSubmodulesCodes = adminSubmodules.map(function (el) {
    return el.code;
  });
  var params = new URL(window.location.href).searchParams;
  // This querypam can have to values: 'showAllLinks' or 'showFilteredLinks'
  var manageLinksPreview = params.get('manageLinksPreview');
  var originalManageLinks = [{
    code: 'COMPANYPAR',
    label: t('MODULE_COMPANY'),
    icon: Building,
    nested: [{
      code: 'COMPANY.USERS',
      label: t('MODULE_COMPANY_USERS'),
      url: withAdminPanelNavigation ? "/org/".concat(organizationSlug, "/admin/company/users/") : "/org/".concat(organizationSlug, "/panel/talent-suite/usuarios/")
    }, {
      code: 'EXTRA_FIELDS_COMPANY',
      label: t('MODULE_COMPANY_EXTRA_FIELDS'),
      url: withAdminPanelNavigation ? "/org/".concat(organizationSlug, "/admin/company/custom-fields/") : "/org/".concat(organizationSlug, "/panel/talent-suite/compania/campos-personalizados/")
    }, {
      code: 'COMPANY.DEPARTMENTS',
      label: t('MODULE_COMPANY_DEPARTMENTS'),
      url: generateSSOUrl('/company/departments')
    }, {
      code: 'COMPANY.CARGOS',
      label: t('MODULE_COMPANY_JOBS'),
      url: generateSSOUrl('/company/jobrole')
    }, {
      code: 'COMPANY.ORGCHART',
      label: t('MODULE_COMPANY_ORGCHART'),
      url: generateSSOUrl('/company/employee-admin-chart')
    }],
    tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
      title: t('MODULE_COMPANY'),
      description: t('MODULE_COMPANY_TOOLTIP_DESCRIPTION')
    })
  }, {
    code: 'account',
    label: t('MODULE_ACCOUNT'),
    icon: Shield,
    url: withAdminPanelNavigation ? "/org/".concat(organizationSlug, "/admin/account/") : "/org/".concat(organizationSlug, "/panel/talent-suite/cuenta/"),
    tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
      title: t('MODULE_ACCOUNT'),
      description: t('MODULE_ACCOUNT_TOOLTIP_DESCRIPTION')
    })
  }, {
    code: 'design',
    label: t('MODULE_APPEREANCE'),
    icon: ColorPalette,
    url: withAdminPanelNavigation ? "/org/".concat(organizationSlug, "/admin/appearance/") : "/org/".concat(organizationSlug, "/panel/talent-suite/configuracion/apariencia/"),
    tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
      title: t('MODULE_APPEREANCE'),
      description: t('MODULE_APPEREANCE_TOOLTIP_DESCRIPTION')
    })
  }, {
    code: 'communication',
    label: t('MODULE_COMMUNICATION'),
    icon: Megaphone,
    url: withAdminPanelNavigation ? "/org/".concat(organizationSlug, "/admin/communication/") : "/org/".concat(organizationSlug, "/panel/talent-suite/configuracion/comunicaciones/"),
    tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
      title: t('MODULE_COMMUNICATION'),
      description: t('MODULE_COMMUNICATION_TOOLTIP_DESCRIPTION')
    })
  }, {
    code: 'automatization',
    label: t('MODULE_AUTOMATIZATIONS'),
    icon: Repeat,
    url: "/org/".concat(organizationSlug, "/panel/administrar/automatizaciones/"),
    tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
      title: t('MODULE_AUTOMATIZATIONS'),
      description: t('MODULE_AUTOMATIZATIONS_TOOLTIP_DESCRIPTION')
    })
  }];
  var newProposalManageLinks = [{
    code: 'COMPANYPAR',
    label: t('MODULE_COMPANY'),
    icon: Building,
    nested: [{
      code: 'COMPANY.USERS',
      label: t('MODULE_COMPANY_USERS'),
      url: "/org/".concat(organizationSlug, "/panel/talent-suite/usuarios/")
    }, {
      code: 'COMPANY.DEPARTMENTS',
      label: t('MODULE_COMPANY_DEPARTMENTS'),
      url: ''
    }, {
      code: 'COMPANY.CARGOS',
      label: t('MODULE_COMPANY_JOBS'),
      url: ''
    }, {
      code: 'EXTRA_FIELDS_COMPANY',
      label: t('MODULE_COMPANY_EXTRA_FIELDS'),
      url: "/org/".concat(organizationSlug, "/panel/talent-suite/compania/campos-personalizados/")
    }, {
      code: 'COMPANY.ORGCHART',
      label: t('MODULE_COMPANY_ORGCHART'),
      url: ''
    }],
    tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
      title: t('MODULE_COMPANY'),
      description: t('MODULE_COMPANY_TOOLTIP_DESCRIPTION')
    })
  }, {
    code: 'account',
    label: t('MODULE_ACCOUNT'),
    icon: Shield,
    url: "/org/".concat(organizationSlug, "/panel/talent-suite/cuenta/"),
    tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
      title: t('MODULE_ACCOUNT'),
      description: t('MODULE_ACCOUNT_TOOLTIP_DESCRIPTION')
    })
  }, {
    code: 'LOGS_ADMIN_COMPANY',
    label: t('MODULE_LOGS'),
    icon: Folder,
    url: '',
    tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
      title: t('MODULE_LOGS'),
      description: t('MODULE_LOGS_TOOLTIP_DESCRIPTION')
    })
  }, {
    code: 'design',
    label: t('MODULE_APPEREANCE'),
    icon: ColorPalette,
    url: "/org/".concat(organizationSlug, "/panel/talent-suite/configuracion/apariencia/"),
    tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
      title: t('MODULE_APPEREANCE'),
      description: t('MODULE_APPEREANCE_TOOLTIP_DESCRIPTION')
    })
  }, {
    code: 'communication',
    label: t('MODULE_COMMUNICATION'),
    icon: Megaphone,
    url: "/org/".concat(organizationSlug, "/panel/talent-suite/configuracion/comunicaciones/"),
    tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
      title: t('MODULE_COMMUNICATION'),
      description: t('MODULE_COMMUNICATION_TOOLTIP_DESCRIPTION')
    })
  }, {
    code: 'automatization',
    label: t('MODULE_AUTOMATIZATIONS'),
    icon: Repeat,
    url: "/org/".concat(organizationSlug, "/panel/administrar/automatizaciones/"),
    tooltip: /*#__PURE__*/_jsx(HelperTooltip, {
      title: t('MODULE_AUTOMATIZATIONS'),
      description: t('MODULE_AUTOMATIZATIONS_TOOLTIP_DESCRIPTION')
    })
  }];
  var filteredManageLinks = newProposalManageLinks
  // Filter only modules available for the user. These are the ones that are at "adminSubmodulesCodes"
  .filter(function (submodule) {
    return adminSubmodulesCodes.includes(submodule.code);
  }).map(function (submodule) {
    if (submodule.nested && submodule.nested.length > 0) {
      return _objectSpread(_objectSpread({}, submodule), {}, {
        nested: _toConsumableArray(submodule.nested.filter(function (nestedLink) {
          var _adminSubmodules$find;
          return (((_adminSubmodules$find = adminSubmodules.find(function (_sub) {
            return _sub.code === submodule.code;
          })) === null || _adminSubmodules$find === void 0 ? void 0 : _adminSubmodules$find.submodules) || []).map(function (el) {
            return el.code;
          }).includes(nestedLink.code);
        }))
      });
    }
    return submodule;
  })
  // Update urls and labels
  .map(function (_submodule) {
    var _adminSubmodules$find2, _adminSubmodules$find3, _submodule$url, _adminSubmodules$find4;
    return _objectSpread(_objectSpread({}, _submodule), {}, {
      label: (_adminSubmodules$find2 = (_adminSubmodules$find3 = adminSubmodules.find(function (el) {
        return el.code === _submodule.code;
      })) === null || _adminSubmodules$find3 === void 0 ? void 0 : _adminSubmodules$find3.label) !== null && _adminSubmodules$find2 !== void 0 ? _adminSubmodules$find2 : _submodule.label,
      // Only replace the URL if, there's no frontend provided URL
      url: ((_submodule$url = _submodule.url) === null || _submodule$url === void 0 ? void 0 : _submodule$url.length) === 0 ? ((_adminSubmodules$find4 = adminSubmodules.find(function (el) {
        return el.code === _submodule.code;
      })) === null || _adminSubmodules$find4 === void 0 ? void 0 : _adminSubmodules$find4.url) || '' : _submodule.url || '',
      nested: _submodule.nested && _submodule.nested.length > 0 ? _submodule.nested.map(function (el) {
        var _adminSubmodules$find5, _adminSubmodules$find6, _adminSubmodules$find7;
        return _objectSpread(_objectSpread({}, el), {}, {
          url: el.url.length === 0 ? (_adminSubmodules$find5 = (_adminSubmodules$find6 = adminSubmodules.find(function (el) {
            return el.code === _submodule.code;
          })) === null || _adminSubmodules$find6 === void 0 ? void 0 : (_adminSubmodules$find7 = _adminSubmodules$find6.submodules.find(function (link) {
            return link.code === el.code;
          })) === null || _adminSubmodules$find7 === void 0 ? void 0 : _adminSubmodules$find7.url) !== null && _adminSubmodules$find5 !== void 0 ? _adminSubmodules$find5 : '' : el.url
        });
      }) : _submodule.nested
    });
  });
  var manageLinks = [];
  if (manageLinksPreview === 'showAllLinks') {
    manageLinks = newProposalManageLinks;
  } else if (manageLinksPreview === 'showFilteredLinks') {
    manageLinks = filteredManageLinks;
  } else {
    manageLinks = originalManageLinks;
  }
  return {
    manageLinks: manageLinks
  };
};

// Returns an URL to navigate to the Talent platform
// The URL is structured based on this example:
// Example URL https://pruebas.acsendo.com/rest/saml3/login?next=https://pruebas.acsendo.com/company/extrafields
var generateSSOUrl = function generateSSOUrl(path) {
  var HOST = isProduction ? 'https://crehana.acsendo.com' : 'https://pruebas.acsendo.com';
  return "".concat(HOST, "/rest/saml3/login?next=").concat(HOST).concat(path);
};